import React, {useRef} from 'react';
import Main from './Main';
import {Provider} from './Provider';

const Wrapper = () => {
    const calendarContainerRef = useRef();
    const appointmentsContainerRef = useRef();
    const headerContainerRef = useRef();

    return <Provider {...{calendarContainerRef, headerContainerRef, appointmentsContainerRef}}>
        <Main {...{calendarContainerRef, headerContainerRef, appointmentsContainerRef}} />
    </Provider>
}

export default Wrapper;